import {
    createUnknownComponentVNode as _$cc,
    className as _$cn,
    createElementVNode as _$ce,
    createVNode as _$cv,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    noop as _$no,
    createCommentVNode as _$ccv,
} from 'intact';
import {FileCardList} from '../fileCard';
import {Icon} from '../icon';
import {Tooltip} from '../tooltip';
import {addStyle, getRestProps} from '../utils';
import {makeStyles} from './styles';
import {senderSendIcon, senderStopIcon, senderAttachSvg} from './icons';
import {_$} from '../../i18n';
import {isInvalid, isNumber, noop} from 'intact-shared';

var _$tmp0 = {
    'aria-hidden': 'true'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        isFocus,
        isDisabled,
        isInputDisabled,
        isGenerating,
        isLoading,
        isSendButtonDisabled,
        isStopButtonDisabled,
        handleKeydown,
        handleInput,
        handleFocus,
        handleBlur,
        handleSendClick,
        send,
        stopGenerate,
    } = this.input;
    
    const {
        getAcceptAttr,
        isMultiple,
        addFiles,
        onInputChange,
        pickFiles,
        removeAttachment,
    } = this.upload;
    const dragController = this.dragController;
    const {handlePaste} = this.pasteController;
    
    let {
        className, style, value, placeholder, readonly,
        width, maxHeight, fileView, uploadButton, dragFile: enableDragFile,
        attachments, uploadProps, buttonTooltip,
    } = this.get();
    const {k} = this.config;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || value === undefined || value === null || value === '') return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const renderSlot = (name, params) => $blocks[name] ? $blocks[name](noop, params) : undefined;
    const headerSlot = renderSlot('header');
    const footerSlot = renderSlot('footer');
    const prefixSlot = renderSlot('prefix');
    const beforeInputSlot = renderSlot('beforeInput');
    const configureSlot = renderSlot('configure');
    const hasHeaderSlot = !isEmptySlot(headerSlot);
    const hasFooterSlot = !isEmptySlot(footerSlot);
    const hasPrefixSlot = !isEmptySlot(prefixSlot);
    const hasBeforeInputSlot = !isEmptySlot(beforeInputSlot);
    const hasConfigureSlot = !isEmptySlot(configureSlot);
    
    const disabled = isDisabled();
    const inputDisabled = isInputDisabled();
    const generating = isGenerating();
    const loading = isLoading();
    const sendButtonDisabled = isSendButtonDisabled();
    const stopButtonDisabled = isStopButtonDisabled();
    const list = attachments || [];
    const hasAttachments = list.length > 0;
    const limit = uploadProps && uploadProps.limit;
    const reachLimit = limit !== undefined && limit !== null && list.length >= Number(limit);
    const isMediaView = fileView === 'media';
    const isDirectory = !!(uploadProps && uploadProps.directory);
    const showToolbarUploadButton = uploadButton === 'toolbar';
    const showListUploadButton = uploadButton === 'list';
    
    const getMediaItemType = (type) => {
        const value = (type || '').toLowerCase().trim();
        if (
            value === 'image' || value === 'video' || value === 'audio' ||
            value.startsWith('image/') || value.startsWith('video/') || value.startsWith('audio/')
        ) {
            return type;
        }
        return undefined;
    };
    
    // card 视图下，所有附件统一按「文件卡」呈现，避免引入额外的文件夹展示语义。
    // media 视图下保留明确媒体类型，但忽略 application/octet-stream 等泛 MIME，继续交给 FileCard 基于 name/src 识别。
    const renderItems = isMediaView
        ? list.map(it => ({...it, type: getMediaItemType(it.type)}))
        : list.map(it => ({...it, type: 'file'}));
    
    // 列表入口即便没有附件也要展示 FileCardList，用来承载前置上传按钮。
    const showAttachmentsArea = showListUploadButton || hasAttachments;
    const onAttachmentClick = (item, e) => {
        this.trigger('attachmentClick', item, e);
    };
    const onAttachmentDelete = (item, e) => {
        this.trigger('attachmentDelete', item, e);
        removeAttachment(item);
    };
    
    const classNameObj = {
        [`${k}-sender`]: true,
        [`${k}-sender-file-view-${fileView}`]: true,
        [`${k}-sender-disabled`]: disabled,
        [`${k}-sender-input-disabled`]: inputDisabled,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    // 整个输入外框 k-sender 的宽度
    if (width != null) {
        style = addStyle(style, {width: isNumber(width) ? `${width}px` : width});
    }
    
    // 整个输入外框 k-sender-shell 的最大高度（与 props maxHeight 一致）；未传时走 styles 中默认 300
    const shellStyle = maxHeight != null
        ? {maxHeight: isNumber(maxHeight) ? `${maxHeight}px` : maxHeight}
        : undefined;
    
    const placeholderText = placeholder != null ? placeholder : _$('输入对话内容（Enter发送， Shift + Enter 换行）');
    
    const getButtonTooltip = (name) => {
        const value = buttonTooltip && buttonTooltip[name];
        return value;
    };
    
    const renderButtonWithTooltip = (button, content, className) => {
        return (
            _$cc(Tooltip, {
                'content': content,
                'className': _$cn(className),
                'children': button
            })
        );
    };
    
    const sendButtonText = _$('发送');
    const stopButtonText = _$('停止生成');
    const uploadButtonText = isDirectory ? _$('上传文件夹') : _$('上传附件');
    const listUploadButtonText = _$('参考内容');
    const currentSendButtonTooltip = getButtonTooltip(generating ? 'stop' : 'send');
    const currentSendButtonAriaLabel = generating ? stopButtonText : sendButtonText;
    const currentUploadButtonTooltip = getButtonTooltip('upload');
    const currentListUploadButtonTooltip = getButtonTooltip('listUpload');
    const sendButtonTitle = currentSendButtonTooltip === undefined ? currentSendButtonAriaLabel : undefined;
    const uploadButtonTitle = currentUploadButtonTooltip === undefined ? uploadButtonText : undefined;
    const listUploadButtonTitle = currentListUploadButtonTooltip === undefined ? listUploadButtonText : undefined;
    
    const defaultSendButtonInner = (
        _$ce(2, 'button', (
            _$ce(2, 'img', null, 1, _$cn(`${k}-sender-send-icon`), {
                'src': generating ? senderStopIcon : senderSendIcon,
                'alt': '',
                'draggable': false
            })
        ), 2, _$cn(`${k}-sender-send-btn`), {
            'type': 'button',
            'disabled': generating ? stopButtonDisabled : sendButtonDisabled,
            'ev-click': handleSendClick,
            'title': sendButtonTitle,
            'aria-label': currentSendButtonAriaLabel
        })
    );
    
    const defaultSendButton = typeof currentSendButtonTooltip === 'string'
        ? renderButtonWithTooltip(defaultSendButtonInner, currentSendButtonTooltip, `${k}-sender-send-tooltip`)
        : defaultSendButtonInner;
    
    const defaultAttachButtonInner = (
        _$ce(2, 'button', null, 1, _$cn(`${k}-sender-attach-btn`), {
            'type': 'button',
            'disabled': inputDisabled || reachLimit,
            'ev-click': pickFiles,
            'title': uploadButtonTitle,
            'aria-label': uploadButtonText,
            'innerHTML': senderAttachSvg
        })
    );
    
    const defaultAttachButton = typeof currentUploadButtonTooltip === 'string'
        ? renderButtonWithTooltip(defaultAttachButtonInner, currentUploadButtonTooltip, `${k}-sender-upload-tooltip`)
        : defaultAttachButtonInner;
    
    const getUploadButtonSlotParams = (position) => ({
        disabled: inputDisabled,
        reachLimit,
        position,
        addFiles,
        pickFiles,
    });
    
    const renderUploadButtonSlot = (position) => {
        const slot = renderSlot('uploadButton', getUploadButtonSlotParams(position));
        return isEmptySlot(slot) ? undefined : slot;
    };
    
    // 附件列表末尾的虚线 + 框
    const listUploadButtonInner = (
        _$ce(2, 'div', [
            _$cc(Icon, {
                'className': _$cn(`${k}-icon-add-bold`)
            }),
            _$ce(2, 'div', listUploadButtonText, 0, _$cn(`${k}-sender-list-upload-text`))
        ], 4, _$cn({
            [`${k}-sender-list-upload`]: true,
            [`${k}-sender-list-upload-disabled`]: inputDisabled,
        }), {
            'ev-click': inputDisabled ? undefined : pickFiles,
            'role': 'button',
            'title': listUploadButtonTitle,
            'aria-label': listUploadButtonText
        })
    );
    
    const listUploadButton = typeof currentListUploadButtonTooltip === 'string'
        ? renderButtonWithTooltip(listUploadButtonInner, currentListUploadButtonTooltip, `${k}-sender-list-upload-tooltip`)
        : listUploadButtonInner;
    
    const toolbarUploadButtonSlot = showToolbarUploadButton ? renderUploadButtonSlot('toolbar') : undefined;
    const listUploadButtonSlot = showListUploadButton ? renderUploadButtonSlot('list') : undefined;
    const showDefaultToolbarUploadButton = showToolbarUploadButton && !toolbarUploadButtonSlot;
    const showToolbarLeft = showToolbarUploadButton;
    
    const sendButtonSlotParams = {
        generating,
        disabled: sendButtonDisabled,
        stopDisabled: stopButtonDisabled,
        loading,
        send,
        stopGenerate,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this),
        'style': style
    }, [
        (hasHeaderSlot) ?
            _$ce(2, 'div', headerSlot, 0, _$cn(`${k}-sender-header`)) :
            undefined,
        _$ce(2, 'div', [
            (showAttachmentsArea) ?
                _$ce(2, 'div', (
                    (isMediaView) ?
                        _$cc(FileCardList, {
                            'items': renderItems,
                            'deleteable': true,
                            'overflow': 'scrollY',
                            'showNameTooltip': true,
                            'ev-click': onAttachmentClick,
                            'ev-delete': onAttachmentDelete,
                            '$blocks': function($blocks) {
                                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                return (
                                    (
                                        (_$blocks['prefix'] = function($super) {
                                            return showListUploadButton && !reachLimit ? (listUploadButtonSlot || listUploadButton) : undefined;
                                        }),
                                        (__$blocks['prefix'] = function($super, data) {
                                            var block = $blocks['prefix'];
                                            var callBlock = function() {
                                                return _$blocks['prefix'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        })
                                    ),
                                    __$blocks
                                );
                            }.call($this, _$em)
                        }) :
                        _$cc(FileCardList, {
                            'items': renderItems,
                            'deleteable': true,
                            'overflow': 'scrollY',
                            'showNameTooltip': true,
                            'ev-click': onAttachmentClick,
                            'ev-delete': onAttachmentDelete,
                            '$blocks': function($blocks) {
                                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                return (
                                    (
                                        (_$blocks['prefix'] = function($super) {
                                            return showListUploadButton && !reachLimit ? (listUploadButtonSlot || listUploadButton) : undefined;
                                        }),
                                        (__$blocks['prefix'] = function($super, data) {
                                            var block = $blocks['prefix'];
                                            var callBlock = function() {
                                                return _$blocks['prefix'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        })
                                    ),
                                    __$blocks
                                );
                            }.call($this, _$em)
                        })
                ), 2, _$cn({
                    [`${k}-sender-attachments`]: true,
                    [`${k}-sender-attachments-${fileView}`]: true,
                })) :
                undefined,
            (hasBeforeInputSlot) ?
                _$ce(2, 'div', beforeInputSlot, 0, _$cn(`${k}-sender-before-input`)) :
                undefined,
            _$ce(2, 'div', [
                (hasPrefixSlot) ?
                    _$ce(2, 'div', prefixSlot, 0, _$cn(`${k}-sender-prefix`)) :
                    undefined,
                _$ce(256, 'textarea', null, 1, _$cn(`${k}-sender-input`), {
                    'rows': 1,
                    'value': value,
                    'placeholder': placeholderText,
                    'disabled': inputDisabled,
                    'readOnly': readonly,
                    'ev-input': handleInput,
                    'ev-keydown': handleKeydown,
                    'ev-paste': handlePaste,
                    'ev-focus': handleFocus,
                    'ev-blur': handleBlur
                }, null, this.textareaRef)
            ], 0, _$cn(`${k}-sender-input-area`)),
            _$ce(2, 'div', [
                (showToolbarLeft) ?
                    _$ce(2, 'div', (
                        (toolbarUploadButtonSlot) ?
                            toolbarUploadButtonSlot :
                            showDefaultToolbarUploadButton ?
                                defaultAttachButton :
                                undefined
                    ), 0, _$cn(`${k}-sender-toolbar-left`)) :
                    undefined,
                (hasConfigureSlot) ?
                    _$ce(2, 'div', configureSlot, 0, _$cn(`${k}-sender-toolbar-middle`)) :
                    undefined,
                _$ce(2, 'div', (
                    ($blocks.sendButton) ?
                        (
                            (_$blocks['sendButton'] = function($super) {
                                return null;
                            }),
                            (__$blocks['sendButton'] = function($super, data) {
                                var block = $blocks['sendButton'];
                                var callBlock = function() {
                                    return _$blocks['sendButton'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            }),
                            __$blocks['sendButton'](_$no, sendButtonSlotParams)
                        ) :
                        defaultSendButton
                ), 0, _$cn(`${k}-sender-toolbar-right`))
            ], 0, _$cn(`${k}-sender-toolbar`)),
            _$ccv(' 放末尾，避免挡住 attachments + input-area 等相邻选择器，且 absolute 不影响布局 '),
            _$ce(64, 'input', null, 1, _$cn(`${k}-sender-file-input`), {
                'type': 'file',
                'accept': getAcceptAttr(),
                'multiple': isMultiple(),
                'directory': isDirectory ? '' : undefined,
                'webkitdirectory': isDirectory ? '' : undefined,
                'ev-change': onInputChange
            }, null, this.fileInputRef)
        ], 0, _$cn({[`${k}-sender-shell`]: true, [`${k}-sender-active`]: isFocus.value && !inputDisabled}), {
            'style': shellStyle
        }),
        (hasFooterSlot) ?
            _$ce(2, 'div', footerSlot, 0, _$cn(`${k}-sender-footer`)) :
            undefined,
        (enableDragFile && dragController.dragOver.value) ?
            _$ce(2, 'div', (
                _$ce(2, 'div', [
                    _$cc(Icon, {
                        'className': _$cn(`${k}-icon-upload`),
                        'size': 'large'
                    }),
                    _$ce(2, 'div', _$('文件拖动到此处即可上传'), 0, _$cn(`${k}-sender-drag-text`))
                ], 4, _$cn(`${k}-sender-drag-card`))
            ), 2, _$cn(`${k}-sender-drag-mask`), _$tmp0) :
            undefined
    ]);
};